<div class="card bg-dark-lighter text-white">
  <div class="card-header">
    {{ "Group Controller" | uppercase }}
    <button
      type="button"
      data-bs-toggle="modal"
      data-bs-target="#modalManageGroup"
      (click)="addGroup()"
      *ngIf="permission.allowUpdating"
    >
      <i class="fa fa-plus"></i>
      Add Group
    </button>
  </div>
  <div class="card-body">
    <div class="table-responsive">
      <div class="group mb-3">
        <table class="table rox-table table-bordered bg-dark">
          <thead>
            <tr>
              <th>№</th>
              <th>Group Name</th>
              <ng-container *ngFor="let head of listPermission">
                <th class="text-center"  *ngIf="head!=='mt5_pe'">
                  {{ head | stringtosplit | titlecase }}
                </th>
              </ng-container>
              <th *ngIf="permission.allowUpdating"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let group of groups; let i = index">
              <td>{{ i + 1 }}</td>
              <td>{{ group.name }}</td>
              <ng-container *ngFor="let headBody of listPermission">
                <td *ngIf="headBody!=='mt5_pe'"
                  class="text-center"
                  [ngStyle]="{
                    color: permissionColors[group.permission[headBody]]
                  }"
                >
                  {{ group.getPermission(group.permission[headBody]) }}
                </td>
              </ng-container>
              <td class="text-right" *ngIf="permission.allowUpdating">
                <a
                  data-bs-toggle="modal"
                  data-bs-target="#modalManageGroup"
                  (click)="editGroup(i, group)"
                >
                  <i class="fa fa-pencil-square-o"></i>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<!-- GROUP MODAL -->
<div class="modal fade fx-modal" id="modalManageGroup" #modalGroup>
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title" *ngIf="manageGroupMode === 'Add'">Add Group</h4>
        <h4 class="modal-title" *ngIf="manageGroupMode === 'Edit'">
          Edit Group
        </h4>
        <button type="button" class="close" data-bs-dismiss="modal">
          &times;
        </button>
      </div>

      <!-- Modal body -->
      <div class="modal-body" *ngIf="group">
        <form class="form form-horizontal" #form="ngForm">
          <div class="row mb-3">
            <div class="col-lg-3 control-label required">Group Name:</div>
            <div class="col-lg-9">
              <input
                type="text"
                name="groupName"
                class="form-control bg-dark"
                [(ngModel)]="group.name"
                #groupName="ngModel"
                required
                [disabled]="manageGroupMode === 'Edit'"
              />
              <div
                *ngIf="
                  (showError && groupName.errors) ||
                  (groupName.invalid && (groupName.dirty || groupName.touched))
                "
              >
                <small
                  class="error error-message"
                  [hidden]="!groupName.errors.required"
                  >Required.</small
                >
              </div>
            </div>
          </div>
          <hr />
          <ng-container *ngFor="let item of listPermission">
            <div class="row mb-3">
              <div class="col-lg-3" style="text-align: right">
                {{ item | stringtosplit | titlecase }}:
              </div>
              <div class="col-lg-9">
                <mat-radio-group
                  class="row"
                  name="{{ item }}"
                  [(ngModel)]="group.permission[item]"
                  ngDefaultControl
                >
                  <mat-radio-button
                    class="col"
                    *ngFor="let value of permissionValue"
                    [value]="value.key"
                  >
                    <span
                      [ngStyle]="{
                        color: permissionColors[value.key]
                      }"
                    >
                      {{ value.name }}
                    </span>
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
          </ng-container>
        </form>
      </div>

      <!-- Modal footer -->
      <div class="modal-footer m-auto">
        <button type="button" class="btn btn-primary mw-120" (click)="save()">
          Save
        </button>
        <button
          type="button"
          class="btn btn-default mw-120"
          data-bs-dismiss="modal"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
</div>
